export class StreemError extends Error {
    constructor(message) {
        super(message);
    }
}
//# sourceMappingURL=streem_error.js.map